/// FOURJS_START_COPYRIGHT(D,2026)
/// Property of Four Js*
/// (c) Copyright Four Js 2026, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("OllamaProvider", ["AIProviderBase"], function (context, cls) {
  /**
   * Ollama provider
   * @class OllamaProvider
   * @memberOf classes
   */
  class OllamaProvider extends cls.AIProviderBase /** @lends classes.OllamaProvider.prototype */ {
    constructor() {
      super("ollama", "Ollama", "remote", { rewrite: true });
    }

    /**
     * @inheritdoc
     */
    _getDirectApiHost() {
      return "http://localhost:11434";
    }

    /**
     * Base URL for Ollama API
     * @returns {string}
     * @private
     */
    _getBaseUrl() {
      return this._buildApiUrl("api/generate");
    }

    /**
     * Rewrite text using Ollama API
     * @inheritDoc
     */
    async rewrite(text, options = {}) {
      const preparedText = this._prepareRewriteInput(text);
      if (preparedText === null) {
        return null;
      }

      const instructions = this._buildRewritePrompt();
      const input = this._buildRewriteInput(preparedText, options);

      const data = await this._request(this._getBaseUrl(), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: {
          model: this._getModel("rewrite"),
          system: instructions,
          prompt: input,
          stream: false
        }
      });

      return this._extractOutputText(data);
    }

    /**
     * Extract output text from Ollama generate payload
     * @param {Object} response
     * @returns {string|null}
     * @private
     */
    _extractOutputText(response) {
      if (!response || typeof response.response !== "string") {
        return null;
      }
      return response.response;
    }
  }

  cls.AIProviderBase.registerProvider(OllamaProvider);
  cls.OllamaProvider = OllamaProvider;
});
